import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../i18n/LanguageContext';

export default function Certifications() {
  const { strings } = useLanguage();

  const certifications = strings.certifications || [];

  // import all images from src/img so localized JSON can reference filenames
  function importAll(r) {
    return r.keys().reduce((images, item) => {
      images[item.replace('./', '')] = r(item);
      return images;
    }, {});
  }

  const _images = importAll(require.context('../img', false, /\.(png|jpe?g|svg)$/));
  const resolveImage = (name) => {
    if (!name) return null;
    if (_images[name]) return _images[name];
    // fallback to absolute public path if provided in JSON
    if (name.startsWith('/')) return name;
    return `/img/${name}`;
  };

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') setSelected(null);
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="page">
      <Hero title={strings.pages.certifications.title} eyebrow={strings.pages.certifications.eyebrow} />
      <main className="page-content max-centered">
        <table className="content-table certifications-table">
          <thead>
            <tr>
              <th>{strings.certificationTableHeaders?.certificate ?? 'Certificate'}</th>
              <th>{strings.certificationTableHeaders?.description ?? 'Description'}</th>
              <th>{strings.certificationTableHeaders?.why ?? 'Why it matters'}</th>
            </tr>
          </thead>
          <tbody>
            {certifications.map((cert, index) => (
              <tr key={index}>
                <td data-label="Certificate">
                  <div
                    className="cert-thumbnail"
                    role="button"
                    tabIndex={0}
                    onClick={() => setSelected(resolveImage(cert.image))}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') setSelected(resolveImage(cert.image));
                    }}
                    aria-label={`Open ${cert.title} preview`}
                  >
                    <img src={resolveImage(cert.image)} alt={cert.title} />
                  </div>
                </td>
                <td data-label="Description">
                  <h3>{cert.title}</h3>
                  <p>{cert.description}</p>
                </td>
                <td data-label="Why it matters">{cert.why}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {selected && (
          <div
            className="image-modal-overlay"
            role="dialog"
            aria-modal="true"
            onClick={() => setSelected(null)}
          >
            <div className="image-modal-wrapper" onClick={(e) => e.stopPropagation()}>
              <button
                className="image-modal-close"
                onClick={() => setSelected(null)}
                aria-label="Close preview"
              >
                ×
              </button>
              <img src={selected} alt="Certificate preview" />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}